var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',[_c('img',{attrs:{"src":require("../../../assets/ico_city.png")}})]),_vm._v(" "),_c('p',[_vm._v("抱歉，您所报名的城市暂未开放路考预约")]),_vm._v(" "),_c('p',[_vm._v("开放招募后会第一时间联系您")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8ab45f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/appointed-road-test/components/NotAvailable.vue
// module id = null
// module chunks = 